module.exports = __webpack_public_path__ + "static/media/evolucion_instalaciones.f19c2b21.png";